import {
  ApplicationInsights,
  type IAppInsights,
  type IApplicationInsights,
} from "@microsoft/applicationinsights-web";

let appInsightsInstance: IApplicationInsights;

export function useAppInsights(): IAppInsights | null {
  const connectionString = import.meta.env
    .VITE_APPLICATION_INSIGHTS_CONNECTION_STRING;
  if (
    !connectionString ||
    (connectionString.endsWith("}}#") && connectionString.startsWith("#{{"))
  ) {
    return null;
  }
  if (!appInsightsInstance) {
    appInsightsInstance = new ApplicationInsights({
      config: {
        connectionString: connectionString,
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        appId: "kundservice-app",
        enableCorsCorrelation: true,
        correlationHeaderDomains: ["*.avtalat.se", "localhost"],
      },
    });
    (appInsightsInstance as ApplicationInsights).loadAppInsights();
  }
  return appInsightsInstance;
}

export function trackCreatedKundkontaktkort(
  url: string,
  verified: boolean,
  puzzelId?: string,
) {
  const appInsights = useAppInsights();
  if (!appInsights) {
    return;
  }
  appInsights.trackEvent({
    name: "Kundkontaktkort Created",
    properties: {
      url,
      verified,
      puzzelId,
    },
  });
}
